import { render, staticRenderFns } from "./ParametricCheckbox.vue?vue&type=template&id=3c715f8c"
import script from "./ParametricCheckbox.vue?vue&type=script&lang=js"
export * from "./ParametricCheckbox.vue?vue&type=script&lang=js"
import style0 from "./ParametricCheckbox.vue?vue&type=style&index=0&id=3c715f8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports